import { render, staticRenderFns } from "./PointsExchange.vue?vue&type=template&id=2bee6391&"
import script from "./PointsExchange.vue?vue&type=script&lang=js&"
export * from "./PointsExchange.vue?vue&type=script&lang=js&"
import style0 from "./PointsExchange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports